import React from 'react';
function ContainerTitle({ title }) {
  return <div className="title"> {title}</div>;
}

ContainerTitle.propTypes = {};

export default ContainerTitle;
